import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type ISurveyCommonData } from 'entities/Surveys/model/types'
import { type SurveySmall } from 'entities/Surveys/model/SurveySmall'

export class SurveyRow extends RowBase<SurveySmall> {
  constructor(origin: SurveySmall) {
    super(origin)
    makeObservableRowBase(this)
  }

  get id() {
    return this.origin.id
  }

  get name() {
    return this.origin.name
  }

  get status() {
    return this.origin.status
  }

  get npsScore() {
    return this.origin.nps_score
  }

  get totalSent() {
    return this.origin.total_sent
  }

  get validReplies() {
    return this.origin.valid_replies
  }

  get undelivered() {
    return this.origin.undelivered
  }

  get expired() {
    return this.origin.expired
  }

  get validRepliesPercent() {
    return this.origin.validRepliesPercent
  }

  get invalidRepliesPercent() {
    return this.origin.invalidRepliesPercent
  }

  get undeliveredPercent() {
    return this.origin.undeliveredPercent
  }

  get expiredPercent() {
    return this.origin.expiredPercent
  }

  get data(): ISurveyCommonData {
    return this.origin.data
  }
}
